import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Imastudent from "../img/Imastudent.png";
import Joinclassdashboard from "../img/Joinclassdashboard.png";
import Joinclasspopup from "../img/Joinclasspopup.png";
import signup from "../img/signup.png";
import studentSignupNew from "../img/studentSignupNew.png";
import tudenting from "../img/tudenting.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",
    },
  },
  detailsgrid: {
    height: "40px",
  },
  detailsgridline: {
    display: "inline-block",
    margin: "auto 30px",
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
    boxShadow: "",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
}));

function HowCanISignup() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div className={classes.accordionSummary}>
        <Typography variant="h5" className={classes.fontHeading}>
          How can I sign up for SwiftGrade?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          To sign up with SwiftGrade you need a class code from your teacher.
          Once you have this, you can follow these steps:
          <br />
          <br />
          Go to our homepage at{" "}
          <a className={classes.hyperlink} href="http://www.goswiftgrade.com">
            {" "}
            goswiftgrade.com{" "}
          </a>
          and click on sign up:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={signup}
          alt="Sign up"
        />
        <Typography className={classes.details} variant="body2">
          Click on 'I'm a Student':
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Imastudent}
          alt="I am a student"
        />
        <Typography className={classes.details} variant="body2">
          Now enter your info plus the 'Class code' that your teacher gave you.{" "}
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={tudenting}
          alt="Student"
        />
        <Typography className={classes.details} variant="body2">
          Finally, verify your email address and input your first and last name
          and you're done!
        </Typography>
      </div>
    </div>
  );
}

function JoinTeachersClass() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div className={classes.accordionSummary}>
        <Typography variant="h5" className={classes.fontHeading}>
          How can I join my teacher's class?
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          To join your teacher's class you need a class code.
          <br />
          <br />
          If you have not yet registered, go through the registration process
          and then enter the class join code that your teacher gave you:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={studentSignupNew}
          alt="register"
        />
        <Typography className={classes.details} variant="body2">
          If you're already registered, log in and then click 'Join class' from
          your dashboard:
        </Typography>
        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Joinclassdashboard}
          alt="register"
        />
        <Typography className={classes.details} variant="body2">
          Next, enter the code that your teacher gave you:
        </Typography>

        <img
          style={{ maxWidth: "800px" }}
          className={classes.imgSize}
          src={Joinclasspopup}
          alt="register"
        />
        <Typography className={classes.details} variant="body2">
          And you will now be enrolled in that class.
        </Typography>
      </div>
    </div>
  );
}

function GettingStartedTopics() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/how-can-i-join`}>
          <JoinTeachersClass />
        </Route>
        <Route path={`${path}/how-can-i-signup`}>
          <HowCanISignup />
        </Route>
      </Switch>
    </>
  );
}

export default GettingStartedTopics;
